"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const react_1 = __importStar(require("react"));
const main_1 = require("./screens/main");
const react_redux_1 = require("react-redux");
const store_1 = require("./store");
const react_router_dom_1 = require("react-router-dom");
const HeroUIProvider_1 = require("./providers/HeroUIProvider");
const tabSessionManager_1 = __importDefault(require("./helpers/tabSessionManager"));
const sign_out_thunk_1 = require("./reducers/slices/user/thunks/sign_out_thunk");
const FaceTecSDK_1 = require("../core-sdk/FaceTecSDK.js/FaceTecSDK");
const Config_1 = require("./Config");
const get__production_keys_1 = require("./api/calls/facetec/get_ production_keys");
const ui_1 = require("./reducers/slices/ui");
const facetecHelper_1 = require("./helpers/facetecHelper");
const constants_1 = require("./constants/constants");
const refresh_user_1 = require("./api/calls/user/refresh_user");
const user_1 = require("./reducers/slices/user/user");
const local_storage_names_1 = require("./constants/local_storage_names");
// Guard to prevent double-initialization in React StrictMode/dev hot reloads
let faceTecInitStarted = false;
let userRefreshStarted = false;
// Component to refresh user data and sync permissions from Firebase on app load
const UserRefreshInitializer = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { user, token } = (0, react_redux_1.useSelector)((state) => state.userState);
    (0, react_1.useEffect)(() => {
        if (userRefreshStarted)
            return;
        if (!(user === null || user === void 0 ? void 0 : user._id) || !token)
            return;
        userRefreshStarted = true;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                console.log("🔄 Refreshing user data from Firebase...");
                const response = yield (0, refresh_user_1.refresh_user)(token);
                if ((response === null || response === void 0 ? void 0 : response.success) && (response === null || response === void 0 ? void 0 : response.content)) {
                    console.log("✅ User data refreshed, permissions:", response.content.permissions);
                    dispatch((0, user_1.setUser)(response.content));
                    // Update localStorage with refreshed user data
                    try {
                        const userLocalStorage = localStorage.getItem(local_storage_names_1.USER_LOCAL_STORAGE);
                        if (userLocalStorage) {
                            const authData = JSON.parse(userLocalStorage);
                            authData.user = response.content;
                            localStorage.setItem(local_storage_names_1.USER_LOCAL_STORAGE, JSON.stringify(authData));
                        }
                    }
                    catch (e) {
                        console.warn("Failed to update localStorage with refreshed user:", e);
                    }
                }
                else {
                    console.warn("⚠️ Failed to refresh user data:", response === null || response === void 0 ? void 0 : response.message);
                }
            }
            catch (error) {
                console.error("❌ Error refreshing user data:", error);
            }
        }))();
    }, [user === null || user === void 0 ? void 0 : user._id, token]);
    return null;
};
// Component to handle FaceTec SDK initialization at app level
const FaceTecSDKInitializer = () => {
    var _a;
    const dispatch = (0, react_redux_1.useDispatch)();
    const accessAuth = (_a = store_1.redux_store.getState().userState) === null || _a === void 0 ? void 0 : _a.accessAuth;
    (0, react_1.useEffect)(() => {
        if (faceTecInitStarted)
            return;
        // Check if there's a code parameter in URL (user coming from mobile/external link)
        const urlParams = new URLSearchParams(window.location.search);
        const hasCodeParam = urlParams.has('code') || window.location.hash.includes('code=');
        // If there's a code parameter but no accessAuth yet, wait for it to load
        if (hasCodeParam && !accessAuth) {
            console.log("⏳ FaceTec SDK - Waiting for accessAuth to load before initialization");
            return;
        }
        // MOBILE BYPASS: Don't initialize FaceTec SDK for mobile users
        // Mobile users are already authenticated via Sky Lifestyle app
        if ((accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.view_type) === constants_1.VIEW_TYPE.MOBILE) {
            console.log("📱 FaceTec SDK - Skipping initialization for mobile user");
            dispatch((0, ui_1.setFacetecSDKReady)(false)); // Not needed for mobile
            return;
        }
        faceTecInitStarted = true;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            try {
                // Set resource directories
                if (typeof FaceTecSDK_1.FaceTecSDK.setResourceDirectory === "function") {
                    FaceTecSDK_1.FaceTecSDK.setResourceDirectory("/facetec/resources");
                }
                if (typeof FaceTecSDK_1.FaceTecSDK.setImagesDirectory === "function") {
                    FaceTecSDK_1.FaceTecSDK.setImagesDirectory("/facetec/images");
                }
            }
            catch (e) {
                console.warn("Unable to set FaceTec directories early:", e);
            }
            // Get production keys
            const response = yield (0, get__production_keys_1.get_production_keys)({ is_web: true });
            if (!(response === null || response === void 0 ? void 0 : response.success)) {
                console.error("Failed to get FaceTec production keys");
                dispatch((0, ui_1.setFacetecSDKReady)(false));
                return;
            }
            const key = response.content.keys;
            Config_1.Config.ProductionKeyText = `{ "domains": "${key.domains}", "expiryDate": "${key.expiryDate}", "key": "${key.key}"}`;
            Config_1.Config.DeviceKeyIdentifier = response.content.key_identifier;
            if (Config_1.Config.ProductionKeyText && Config_1.Config.DeviceKeyIdentifier) {
                console.log("🔑 Initializing FaceTec SDK at app level...");
                Config_1.Config.initializeFromAutogeneratedConfig(FaceTecSDK_1.FaceTecSDK, function (initializedSuccessfully) {
                    console.log("✅ FaceTec SDK initialization result:", initializedSuccessfully);
                    // Update config and Redux state
                    Config_1.Config.didSucceed = initializedSuccessfully;
                    dispatch((0, ui_1.setFacetecSDKReady)(initializedSuccessfully));
                    // Apply FaceTec theme (orange colours from Config.js)
                    if (initializedSuccessfully) {
                        (0, facetecHelper_1.onFaceTecSDKInitializationSuccess)();
                    }
                }, Config_1.Config.ProductionKeyText, Config_1.Config.DeviceKeyIdentifier);
            }
        }))();
    }, [accessAuth === null || accessAuth === void 0 ? void 0 : accessAuth.view_type]);
    return null;
};
// Component to handle tab session manager
const TabSessionManagerWrapper = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        // Initialize tab session manager
        const sessionManager = new tabSessionManager_1.default(() => {
            // Logout callback when last tab closes
            dispatch((0, sign_out_thunk_1.sign_out_thunk)());
        });
        // Cleanup on unmount
        return () => {
            sessionManager.cleanup();
        };
    }, [dispatch]);
    return null;
};
const App = () => {
    return (react_1.default.createElement(react_redux_1.Provider, { store: store_1.redux_store },
        react_1.default.createElement(HeroUIProvider_1.HeroUIProvider, null,
            react_1.default.createElement(react_router_dom_1.HashRouter, { future: {
                    v7_startTransition: true,
                    v7_relativeSplatPath: true,
                } },
                react_1.default.createElement(UserRefreshInitializer, null),
                react_1.default.createElement(FaceTecSDKInitializer, null),
                react_1.default.createElement(TabSessionManagerWrapper, null),
                react_1.default.createElement(main_1.MainScreen, null)))));
};
exports.App = App;
